import React, { PropsWithChildren } from 'react';

import ChevronDown from '@gravity-ui/icons/ChevronDown';
import ChevronRight from '@gravity-ui/icons/ChevronRight';
import { Button } from '@gravity-ui/uikit';
import clx from 'classnames';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';

import styles from './FormCard.module.scss';

export const FormCard = (
    props: PropsWithChildren<{
        cardKey: string;
        cardTitle: string;
        openCardName: string;
        handleOpenCard: (cardKey: string) => void;
    }>,
) => {
    const { cardKey, cardTitle, openCardName, children, handleOpenCard } = props;
    return (
        <ErrorBoundary>
            <div className={styles.formCardContainer} id={cardKey} key={openCardName}>
                <h3 className={styles.formCard__header}>{cardTitle}</h3>
                <Button view="flat" className={styles.formCardButton} onClick={() => handleOpenCard(cardKey)}>
                    <div className={styles.formCardButton__content}>
                        {openCardName === cardKey ? <ChevronDown /> : <ChevronRight />}
                        {cardTitle}
                    </div>
                </Button>
                <div
                    className={clx(
                        styles.formCard,
                        openCardName === cardKey ? styles.formCard__content_visible : styles.formCard__content_hidden,
                    )}
                >
                    {children}
                </div>
            </div>
        </ErrorBoundary>
    );
};
